import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=23cb2e78&scoped=true&"
import script from "./Investment.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Investment.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Investment.vue?vue&type=style&index=0&id=23cb2e78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb2e78",
  null
  
)

export default component.exports